import { render, staticRenderFns } from "./SettingsLocalisationCountries.vue?vue&type=template&id=c9c785d4&"
import script from "./SettingsLocalisationCountries.vue?vue&type=script&lang=ts&"
export * from "./SettingsLocalisationCountries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports